import styled from 'styled-components';
import { COLORS } from '@/styles/colorTheme';

export const Container = styled.button`
  border: 1px solid;
  cursor: pointer;
  text-align: center;

  padding-top: ${(props) => props.py};
  padding-bottom: ${(props) => props.py};
  padding-left: ${(props) => props.px};
  padding-right: ${(props) => props.px};
  border-radius: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;

  width: 'fit-content';

  border-color: ${(props) => (props.selected ? COLORS.Primary500 : '#ffffff')};

  :hover {
    background: ${(props) => props.color};
  }
  :active {
    background: ${COLORS.Background300};
  }
`;

export const TextWrapper = styled.div`
  max-width: ${(props) => (props.maxWidth ? props.maxWidth : 'none')};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  display: flex;
  justify-content: center;
  align-items: center;
`;
